module.exports = __webpack_public_path__ + "static/media/configuration.c00050a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/configuration.png
// module id = 1103
// module chunks = 0